import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=3e1dac97&"
import script from "./event-card.vue?vue&type=script&lang=js&"
export * from "./event-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports